export default "__VITE_ASSET__81c1412c__"